export const cdnFilenameRegexp = /\.[a-z]+\/(?<filename>[\w-]*)\./;
